import React from 'react';
import styled from 'styled-components';
import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-scroll';

const Franchise = () => {
  return (
    <FranchiseBlock>
      <FranchiseBlockContainer>
        <FranchiseBlockTitle>
          Что входит во франшизу EnerGO?
        </FranchiseBlockTitle>
        <FranchiseBlockSubTitle>
          Франшиза EnerGO даст вам возможность организовать собственную сеть в
          Вашем городе и получать пассивный доход
          <br /> с минимальными вложениями!
        </FranchiseBlockSubTitle>
        <FranchiseBlockSubTitleUl>
          <FranchiseBlockSubTitleLi>
            Зарядные станции с пауэрбэнками
          </FranchiseBlockSubTitleLi>
          <FranchiseBlockSubTitleLi>
            Программное обеспечение
          </FranchiseBlockSubTitleLi>
          <FranchiseBlockSubTitleLi>
            Обучение франчайзи и персонала
          </FranchiseBlockSubTitleLi>
          <FranchiseBlockSubTitleLi>
            Руководство фирменным стилем
          </FranchiseBlockSubTitleLi>
          <FranchiseBlockSubTitleLi>
            Пользовательская и техническая поддержка 24/7
          </FranchiseBlockSubTitleLi>
          <FranchiseBlockSubTitleLi>
            Доступ в личный кабинет франчайзи
          </FranchiseBlockSubTitleLi>
        </FranchiseBlockSubTitleUl>
        <Link to="contact-form">
          <FranchiseBlockButton>
            Присоединиться
            <BsArrowRight style={{ marginLeft: '15px' }} />
          </FranchiseBlockButton>
        </Link>
      </FranchiseBlockContainer>
    </FranchiseBlock>
  );
};

const FranchiseBlock = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: #ffdc00;
  border-radius: 16px;
  margin-top: 13px;
  margin-bottom: 25px;
  @media (max-width: 1135px) {
    margin-top: 0;
    margin-bottom: -15px;
  }
`;

const FranchiseBlockContainer = styled.div`
  width: 58%;
  padding: 41px 38px;
  @media (max-width: 1135px) {
    width: 100%;
    padding: 41px 32px;
  }
  @media (max-width: 600px) {
    padding: 30px 25px;
  }
`;

const FranchiseBlockTitle = styled.div`
  font-weight: 600;
  font-size: 40px;
  @media (max-width: 600px) {
    font-size: 28px;
    line-height: 40px;
    margin-top: -10px;
  }
`;

const FranchiseBlockSubTitle = styled.p`
  font-weight: 400;
  font-size: 20px;
  margin-top: 34px;
  line-height: 32px;
  margin-bottom: 0;
  @media (max-width: 600px) {
    margin-top: 33px;
  }
`;

const FranchiseBlockSubTitleLi = styled.li`
  font-weight: 400;
  font-size: 20px;
  list-style: outside;
  margin-bottom: 17px;
  @media (max-width: 600px) {
    line-height: 32px;
    margin-bottom: 4px;
  }
`;

const FranchiseBlockSubTitleUl = styled.ul`
  margin-top: 6px;
  @media (max-width: 600px) {
    padding-left: 30px !important;
    padding-top: 11px;
  }
`;

const FranchiseBlockButton = styled.button`
  font-weight: 700;
  font-size: 24px;
  background: transparent;
  margin-top: 27px;
  color: #26292d;
  &:hover {
    text-decoration: underline;
  }
  @media (max-width: 600px) {
    margin-top: 19px;
  }
`;

export default Franchise;
